module.exports = __webpack_public_path__ + "static/media/cart.b5ef7bf1.svg";